import { URI } from '@wix/communities-forum-client-commons';
import getOuterUrl from './get-outer-url';
import { buildCustomizedUrl } from './build-customized-url';

import { isExperimentEnabled } from '../selectors/experiments-selectors';
import { getSectionUrl } from '../../common/store/location/location-selectors';

export const buildNewDeepCommentUrl = (
  categorySlug,
  postSlug,
  commentId,
  url = '',
  searchTerm = '',
) => {
  const query = new URI(url).query();
  const queryString = query
    ? `?${query}${searchTerm ? '&' + searchTerm : ''}`
    : searchTerm
    ? `?${searchTerm}`
    : '';

  return `/${categorySlug}/${postSlug}/dl-${commentId}${queryString}`;
};

const COMMENT_ID_PLACEHOLDER = '____commentId____';

export const buildDeepLinkUrl = (state) => {
  const path = `/main/comment/${COMMENT_ID_PLACEHOLDER}`;
  const sectionUrl = getSectionUrl(state);
  return getOuterUrl(path, sectionUrl);
};

export const buildDeepLink = (deepLinkUrl, commentId, postId) => {
  const url = URI(deepLinkUrl.replace(COMMENT_ID_PLACEHOLDER, commentId));
  if (postId) {
    url.setQuery({ postId });
  }
  return url.toString();
};
